import {html, LitElement, PropertyValues} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import WaveSurfer from 'wavesurfer.js';
import {audioInputEntry} from './sp-audio-input-entry.styles';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit-html/directives/class-map.js';
import {getIcon} from "../../../../styles/icons";

@customElement('sp-audio-input-entry')
export class SpAudioInputEntry extends LitElement {
    @property({type: Object})
    value: Blob | string;
    @property({type: Boolean})
    viewMode;
    @state()
    processing = false;
    @state()
    started = false;

    waveSurferInstance: WaveSurfer;
    objectURL;

    static styles = [
        audioInputEntry
    ];

    togglePlay() {
        if (this.started) {
            this.waveSurferInstance.pause();
            this.started = false;
        } else {
            this.waveSurferInstance.play();
            this.started = true;
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.waveSurferInstance.destroy();
        if (this.objectURL)
            URL.revokeObjectURL(this.objectURL);
    }

    protected updated(_changedProperties: PropertyValues) {
        super.updated(_changedProperties);
        if (_changedProperties.has('value')) {
            if (this.waveSurferInstance) this.waveSurferInstance.destroy();
            this.waveSurferInstance = WaveSurfer.create({
                container: this.shadowRoot.querySelector('.wave') as HTMLElement,
                waveColor: getComputedStyle(this.shadowRoot.host).getPropertyValue('--sp-audio-input-wave-color'),
                progressColor: getComputedStyle(this.shadowRoot.host).getPropertyValue('--sp-audio-input-wave-progress-color'),
                cursorColor: getComputedStyle(this.shadowRoot.host).getPropertyValue('--sp-audio-input-cursor-color'),
                barWidth: 2,
                barRadius: 1.5,
                barGap: 1.5,
                height: this.shadowRoot.querySelector('.wave').clientHeight,
                hideScrollbar: true
            });
            this.processing = true;
            if (typeof this.value === 'object') {
                if (this.objectURL)
                    URL.revokeObjectURL(this.objectURL);
                this.objectURL = URL.createObjectURL(this.value);
                this.waveSurferInstance.load(this.objectURL);
            } else {
                this.waveSurferInstance.load(this.value);
            }
            this.waveSurferInstance.on('finish', () => {
                this.started = false;
            });
            this.waveSurferInstance.on('ready', () => {
                this.processing = false;
            });
        }
    }

    protected render() {
        // TODO: show animation during processing
        return html`
            <div
                part="container"
                class=${ classMap({
                    container: true,
                    'view-mode': this.viewMode
                })}>
                ${when(!this.viewMode,
                        () => html`
                            <sp-button class="delete" iconSizePercent=50 icon="url(${getIcon('trash', { color: 'grey-dark', size: 'x128' })})"
                                       @click=${() => {
                            this.dispatchEvent(new Event('delete', {bubbles: true, composed: true}))
                        }}>
                            </sp-button>`,
                        () => html`
                            <sp-button class=${ classMap({
                                    play: 1,
                                    'view-mode': this.viewMode,
                                    stopped: !this.started
                                })}
                               iconSizePercent=50
                               icon="url(${this.started ? getIcon('pause', { size: 'x128' }) : getIcon('play', { size: 'x128' })})"
                               @click=${this.togglePlay}></sp-button>
                    `)}
                <div class=${ classMap({
                    wave: true,
                    'view-mode': this.viewMode
                })}></div>
                ${when(!this.viewMode, () => html`
                <sp-button class="play"
                           part="play"
                           iconSizePercent=50
                           icon="url(${this.started ? getIcon('pause', { size: 'x128' }) : getIcon('play', { size: 'x128' })})"
                           @click=${this.togglePlay}></sp-button>
            `) }
            </div>`;
    }
}


